module.exports = __webpack_public_path__ + "img/OGG_Background_Yellow.b58add23.png";